import {
  ApiScreeningResultResponse,
  ScreeningRuleCheck,
  ScreeningStatus,
} from "../entities/Screening";

export default class ScreeningResultMapper {
  static fromApi(items: ApiScreeningResultResponse): ScreeningRuleCheck[] {
    return (items || []).map((it) => ({
      rule: it.rule,
      provider: it.provider,
      detail: it.detail,
      status: this.normalizeStatus(it.status),
    }));
  }

  /**
   * Normalize raw API status (e.g. CLEAR, OK, AVERT., ALERTE, ECHEC, FAIBLE, STANDARD, HIGH)
   * into a canonical, lowercase ScreeningStatus understood by the UI.
   */
  private static normalizeStatus(status: string): ScreeningStatus {
    const s = (status || "").toLowerCase().trim();

    // Happy path / no-risk statuses
    if (s === "ok") return "ok";
    if (s === "clear") return "clear";

    // Warnings (moderate risk / attention required)
    if (s.startsWith("avert")) return "avert"; // "AVERT." -> "avert"
    if (s === "faible" || s === "ok") return "ok";
    if (s === "standard" || s === "moyen") return "standard";

    // High / blocking risk statuses
    if (s === "alerte") return "alerte";
    if (s === "echec") return "echec";
    if (s === "high" || s === "eleve" || s === "élevé") return "high";

    // Fallback: keep normalized string so UI can still display something meaningful
    return (s || "unknown") as ScreeningStatus;
  }
}
